import { useEffect, useState } from 'react';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

const TEST_NAME = 'mwRemovePromiseDrawer';

export const useIsMwRemovePromiseDrawerVariant = (): boolean | null => {
    const { isMobile } = useServerVarsContext();

    const [isMwRemovePromiseDrawerVariant, setMwRemovePromiseDrawerVariant] = useState<
        boolean | null
    >(null);

    useEffect(() => {
        setMwRemovePromiseDrawerVariant(
            !!isMobile && getAbTestV2(TEST_NAME)?.variant === 'variant'
        );
    }, [isMobile]);

    return isMwRemovePromiseDrawerVariant;
};

export const useTrackMwRemovePromiseDrawerTest = (): void => {
    useEffect(() => {
        trackAbTestV2Variant(TEST_NAME);
    }, []);
};
